<template>
    <div id="footer-map" class="footer-map" @mouseleave="showMapBox = true;" v-if="pizzeriaInfo.footer_map !== undefined && pizzeriaInfo.footer_map !== null">
        <div class="footer-map-box" :class="{'collapsed': !showMapBox}">
            <div class="footer-map-box-content">
                <div class="footer-map-title">
                    {{phrases.MAP_TEXT_FREE_DELIVERY}}
                    <span>{{phrases['TEXT_IN_CITY_' + city.toUpperCase()]}}</span>
                </div>
                <div class="footer-map-description">
                    {{phrases.MAP_TEXT_DELIVERY_ZONE}}
                </div>
                <div class="button-black-border" @click="showMapBox = false;">
                    {{phrases.MAP_TEXT_DELIVERY_DETAILS}}
                </div>
            </div>
        </div>
        <div class="button-black-border button-change-city" :class="{'active': !showMapBox}" @click="setChangeLocation">
          {{phrases.TEXT_BUTTON_LOCATION_TITLE_ON_MAIN_MAP}}
        </div>
        <div class="map" v-html="pizzeriaInfo.footer_map"></div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Utils from "../Utils";

    export default {
        name: "Map",
        data: function(){
            return {
                showMapBox: true,
            };
        },
        computed:{
            ...mapGetters('app', {
                pizzeriaInfo: 'getPizzeriaInfo',
                city: 'getCityCode',
                phrases: 'getPhrases',
            }),
        },
        mixins: [Utils],
    }
</script>

<style scoped lang="scss">
    .footer-map{
        position: relative;
        &-box{
            position: absolute;
            height: 100%;
            width: 100%;
            top: 0;
            left: 0;
            background-color: rgba(255,232,214,0.6);
            transition: all .256s ease-in-out;
            z-index: 2;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: center;

            &.collapsed{
                transform: scale(0);
                opacity: 0;
            }

            &-content{
                max-width: 660px;
                margin: 0 auto;
            }
        }

        &-title{
            font-family: 'Panton Bold',sans-serif;
            font-size: 2.25rem;
            line-height: 2.75rem;
            text-transform: uppercase;
        }
        &-description{
            font-family: 'Panton Semibold',sans-serif;
            font-size: 1.5rem;
            line-height: 1.75rem;
            margin-top: 1.5rem;
        }

        .button-black-border{
            cursor: pointer;
            display: inline-block;
            position: relative;
            font-family: 'Panton Semibold',sans-serif;
            font-size: 1.5rem;
            line-height: 1;
            text-align: center;
            padding: 0.75rem 1.5rem;
            margin-top: 1.5rem;
            border: 0.125rem solid #000;
            border-radius: 0.25rem;
            transition: all .128s ease-in-out;
            color: #000;
            text-decoration: none;

            &:hover{
                font-family: 'Panton Extrabold',sans-serif;
                background-color: #000;
                color: #fff;
            }
        }

        .button-change-city{
            position: absolute;
            left: -1000px;
            &.active{
                left: 0.5rem;
                bottom: 3rem;
            }
        }
    }
</style>
